module.exports = __webpack_public_path__ + "media/house-and-land.9e49de65.svg";